import React from 'react';
import { useFreeUser } from 'v2/hooks/useFreeUser';
import { Link } from 'react-router-dom';
import styles from './freeTopBanner.module.scss';
import classnames from 'classnames';
import { ReactComponent as LockIcon } from 'v2/icons/lock.svg';
import { useAppSelector } from 'store';

export const FreeTopBanner = () => {
  const waitlisted =
    useAppSelector((store) => store.user?.user?.waitlisted) ?? true;
  const [isFreeUser] = useFreeUser();

  return isFreeUser ? (
    <div className={classnames(styles.freeTopBanner)}>
      <LockIcon />
      <p>
        You are currently using a free account.
        {!waitlisted && (
          <>
            To unlock additional features and functionality
            <Link to="/settings/subscription"> subscribe here.</Link>
          </>
        )}
      </p>
    </div>
  ) : null;
};
